import Axios from 'axios';
import { getAuthApiBase } from './authBase';
import { getIdpApiBase } from './idpBase';

export const searchAuditTrailApi = (data) => {
    if(data.authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'audit-trail/records',
            params: {
                memberId : data.userId,
                merchantId : data.merchantId,
                orderBy : data.orderBy,
                orderType : data.orderType,
                nRecords : data.nRecords,
                page : data.page,
                keyword : data.keyword,
                moduleId : data.moduleId,
                typeId : data.typeId,
                startDate : data.startDate,
                endDate : data.endDate
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': data.authToken,
                'deviceUniqueId' : data.deviceId
            }
        });
    };
};

export const viewAuditTrailApi = (data) => {
    if (data.authToken != null && data.id != null) {
        return Axios({
            method: 'get',
            url: getIdpApiBase() + 'v2/member/' + data.id,
            headers: {
                authToken: data.authToken,
                deviceUniqueId: data.deviceId,
            },
        });
    }
};

export const listModuleNameApi = ({ authToken, deviceId }) => {
    if (authToken != null) {
        return Axios({
            method: 'get',
            url: getAuthApiBase() + 'v2/menus',
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};